import React, { useState } from 'react';
import { FileText, CheckCircle, Clock, Upload, Search, ChevronRight, File, MoreVertical, FolderOpen } from 'lucide-react';
export function DocumentHubSection() {
  const [searchQuery, setSearchQuery] = useState('');
  // Mock data for recent documents
  const recentDocuments = [{
    id: 1,
    title: 'Employment Contract',
    type: 'pdf',
    updatedAt: 'Updated 2 days ago'
  }, {
    id: 2,
    title: 'Non-Disclosure Agreement',
    type: 'pdf',
    updatedAt: 'Updated 5 days ago'
  }, {
    id: 3,
    title: 'Lease Agreement',
    type: 'doc',
    updatedAt: 'Uploaded Nov 28'
  }, {
    id: 4,
    title: 'Business Partnership Contract',
    type: 'pdf',
    updatedAt: 'Uploaded Nov 25'
  }];
  const handleViewDocument = (id: number) => {
    console.log(`Viewing document ${id}`);
  };
  const handleViewAllDocuments = () => {
    console.log('Viewing all documents');
  };
  const handleRequestReview = () => {
    console.log('Requesting document review');
  };
  const handleUpload = () => {
    console.log('Opening upload dialog');
  };
  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Searching:', searchQuery);
  };
  return <div className="bg-white border border-borderColor rounded-xl p-6 lg:p-7 shadow-sm" data-id="element-184">
      {/* Header */}
      <div className="flex items-start justify-between mb-4 flex-wrap gap-3 pt-[10px]" data-id="element-185">
        <div className="flex items-center gap-3" data-id="element-186">
          <div className="p-2 bg-aliceBlue rounded-lg" data-id="element-187">
            <FolderOpen className="w-5 h-5 text-violetBlue" data-id="element-188" />
          </div>
          <div data-id="element-189">
            <h3 className="text-lg font-semibold text-primary" data-id="element-190">Document Hub</h3>
            <p className="text-sm text-secondary" data-id="element-191">
              Centralized document management and organization
            </p>
          </div>
        </div>

        {/* Utility Row */}
      </div>

      {/* Two-column layout - reversed on mobile */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-192">
        {/* Left Column - Recent Documents */}
        <div className="order-2 lg:order-1" data-id="element-193">
          <div className="flex items-center gap-2 mb-3" data-id="element-194">
            <FileText className="w-4 h-4 text-violetBlue" data-id="element-195" />
            <h4 className="text-base font-semibold text-primary" data-id="element-196">
              Recent Documents
            </h4>
          </div>

          {recentDocuments.length > 0 ? <>
              <div className="space-y-1" data-id="element-197">
                {recentDocuments.map(doc => <div key={doc.id} onClick={() => handleViewDocument(doc.id)} className="flex items-center gap-3 p-2.5 rounded-lg hover:bg-aliceBlue transition-colors cursor-pointer" data-id="element-198">
                    <div className="flex-shrink-0" data-id="element-199">
                      <File className="w-5 h-5 text-disabled" data-id="element-200" />
                    </div>
                    <div className="flex-1 min-w-0" data-id="element-201">
                      <p className="text-sm font-medium text-primary truncate" data-id="element-202">
                        {doc.title}
                      </p>
                    </div>
                  </div>)}
              </div>

              <button onClick={handleViewAllDocuments} className="mt-3 flex items-center gap-1 text-sm text-violetBlue hover:text-[#6844E8] font-medium transition-colors" data-id="element-203">
                <span data-id="element-204">View all documents</span>
                <ChevronRight className="w-4 h-4" data-id="element-205" />
              </button>
            </> :
        // Empty state
        <div className="flex flex-col items-center justify-center py-6 text-center" data-id="element-206">
              <div className="w-14 h-14 bg-aliceBlue rounded-full flex items-center justify-center mb-3" data-id="element-207">
                <FolderOpen className="w-7 h-7 text-disabled" data-id="element-208" />
              </div>
              <p className="text-sm font-medium text-primary mb-1" data-id="element-209">
                No documents yet
              </p>
              <p className="text-sm text-secondary mb-3" data-id="element-210">
                Upload your first document to get started
              </p>
              <button onClick={handleUpload} className="px-4 py-2 bg-violetBlue hover:bg-[#6844E8] text-white text-sm font-medium rounded-lg transition-colors" data-id="element-211">
                Upload Document
              </button>
            </div>}
        </div>

        {/* Right Column - Document Review */}
        <div className="order-1 lg:order-2 bg-aliceBlue border border-borderColor rounded-xl p-5" data-id="element-212">
          <div className="flex items-center gap-2 mb-3" data-id="element-213">
            <CheckCircle className="w-5 h-5 text-turquoise" data-id="element-214" />
            <h4 className="text-base font-semibold text-primary" data-id="element-215">
              Document Review
            </h4>
          </div>

          <p className="text-sm text-secondary mb-4 leading-relaxed" data-id="element-216">
            Have our legal experts review your document for clarity, risk, and
            compliance.
          </p>

          {/* Benefits */}
          <div className="space-y-2.5 mb-4" data-id="element-217">
            <div className="flex items-start gap-3" data-id="element-218">
              <Clock className="w-4 h-4 text-turquoise mt-0.5 flex-shrink-0" data-id="element-219" />
              <span className="text-sm text-secondary" data-id="element-220">48-hour turnaround</span>
            </div>

            <div className="flex items-start gap-3" data-id="element-221">
              <CheckCircle className="w-4 h-4 text-turquoise mt-0.5 flex-shrink-0" data-id="element-222" />
              <span className="text-sm text-secondary" data-id="element-223">
                Confidential and secure
              </span>
            </div>
          </div>

          {/* What you'll get box */}

          {/* CTA */}
          <button onClick={handleRequestReview} className="w-full bg-white border-2 border-violetBlue text-violetBlue hover:bg-white/80 font-medium py-2.5 px-4 rounded-lg transition-colors mb-2" data-id="element-224">
            Request Review
          </button>
        </div>
      </div>
    </div>;
}